import { useTheme, Box, Typography, IconButton } from "@mui/material";
import {
  ArrowForwardIosRounded,
  KeyboardArrowDownRounded,
} from "@mui/icons-material";

const Accordion = ({ isExpanded, toggleExpanded, title, children }) => {
  const theme = useTheme();
  return (
    <Box sx={{ display: "flex", justifyContent: "center" }}>
      <Box
        className="square"
        sx={{
          mt: "2vw",
          width: "90%",
          height: "100%",
          p: 3,
          cursor: "pointer",
          boxShadow: theme.palette.squareBoxShadow,
          border: theme.palette.tinyBorder,
        }}
      >
        <Box
          sx={{ display: "flex", alignItems: "center" }}
          onClick={toggleExpanded}
        >
          <Box>
            <IconButton>
              {isExpanded ? (
                <KeyboardArrowDownRounded sx={{ fontSize: "1.3rem" }} />
              ) : (
                <ArrowForwardIosRounded sx={{ fontSize: "0.9rem" }} />
              )}
            </IconButton>
          </Box>
          <Typography
            className="noselect"
            sx={{
              color: theme.palette.text.main,
              alignSelf: "flex-end",
              fontSize: "18px",
              fontWeight: "bold",
            }}
          >
            {title}
          </Typography>
        </Box>
        <Box>{isExpanded && children}</Box>
      </Box>
    </Box>
  );
};

export default Accordion;
